module.exports = __webpack_public_path__ + "static/HandBag1_zps0u8iiyba-968e7e0cd4c63d793377dec91403d890.jpg";